import React, { useEffect, useState } from 'react';

import { Container, SubMenuContainer } from './styles';

import NavbarLink from 'component/landing/navbar-link';
import useClickAway from 'hooks/useClickAway';
import useIsMobile from 'hooks/useIsMobile';
import useIsInViewport from 'hooks/useIsInViewport';
import useScrollDirection, { scrollDirections } from 'hooks/useScrollDirection';

function SimpleSubMenu({ children, text }) {
  const {
    elementRef,
    isOffToRight,
    offsetToRight,
    recalculate,
  } = useIsInViewport();
  const direction = useScrollDirection();
  const isMobile = useIsMobile();
  const { ref, isActive, toggleIsActive, setIsActive } = useClickAway();

  const toggler =
    typeof text === 'string' ? (
      <NavbarLink hasSubMenu>{text}</NavbarLink>
    ) : (
      text
    );

  useEffect(() => {
    if (direction === scrollDirections.DOWN && isActive && !isMobile) {
      setIsActive(false);
    }
  }, [direction, isActive]);

  useEffect(() => {
    if (isActive) {
      recalculate();
    }
  }, [isActive]);

  return (
    <Container ref={ref}>
      <div onClick={toggleIsActive}>{toggler}</div>
      <SubMenuContainer
        ref={elementRef}
        isInViewport={isOffToRight}
        offsetToRight={offsetToRight}
        isActive={isActive}
      >
        <div className="menu-container">
          <div className="content">{children}</div>
        </div>
      </SubMenuContainer>
    </Container>
  );
}

export default SimpleSubMenu;
